import { Component, OnInit, Input } from "@angular/core";

@Component({
	selector: "svg-image",
	templateUrl: "./svg.component.html",
	styleUrls: ["./svg.component.css"]
})
export class SvgComponent implements OnInit {
	@Input() name: String;
	@Input() color: String;
	@Input() width: String;
	@Input() height: String;
	constructor() {}

	ngOnInit() {}

	get absUrl() {
		return window.location.href;
	}
}
